export default __webpack_public_path__ + "static/cautious-4e21e32505914c565352b7cb18a7083f.svg";